import {
    Component,
    ojs,
    app,
    state,
    v,
    payload,
    component,
} from "modular-openscriptjs";
import { pageInfo, scrollToTop, eParse, inform, empty, monetary, consoleErrorOnLocal } from "../../../helpers";
import SolidIcon from "../../Blocks/SolidIcon";
import InfiniteScroll from "../../Blocks/InfiniteScroll";
import Spinner from "../../Blocks/Spinner";
import { dom } from "../../../fotastart";
import { dc, api, STRINGS } from "../../../declarations";
import { $e } from "../../../ojs.events";

const h = app("h");
const router = app("router");
const broker = app("broker");

ojs(SolidIcon, InfiniteScroll, Spinner);

export default class ViewServices extends Component {
    businessId = null;
    loading = state(true);
    page = 1;
    lastPage = false;
    initialized = false;

    $$system = {
        needs: {
            search: (ed, event) => this.debounceSearch(),
        },
    };

    $$service = {
        deleted: (ed, event) => {
            const { id } = eParse(ed);
            const card = dom.get(`[service-card-id="s-${id}"]`);
            if (card) {
                card.remove();
            }
        },
    };

    debounceTimer = null;
    debounceSearch() {
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            this.page = 1;
            this.lastPage = false;
            const holder = dom.get("[hook='vs-services-list']");
            if (holder) dom.empty(holder);
            this.fetchServices();
        }, 500);
    }

    async init() {
        if (this.initialized) return;
        this.initialized = true;
        this.businessId = router.params.companyId;
        this.page = 1;
        this.lastPage = false;
        this.fetchServices();
    }

    $_mounted(componentId) {
        let c = component(componentId);

        if (c) c.init();
    }

    async fetchServices(marker) {
        let spinner = null;
        
        
        if (marker) {
          spinner = h.Spinner({
            class: "p-3",
            parent: marker,
            resetParent: true,
          });
        } else {
          this.loading.value = true;
        }
        
        const holder = dom.get("[hook='vs-services-list']");

        if(holder?.children.length === 0) {
          this.lastPage = false;
          this.page = 1;
        }

        if (this.lastPage) {
            return;
        }

        try {
            let payload = {
                page: this.page,
                interval: 10,
                search: dc.searchQuery || "",
                "organization[id]": this.businessId,
                "organization[type]": "Company",
            };

            const res = await api.get(
                `companies/${this.businessId}/services`,
                payload,
                { silent: true },
            );

            if (!res && marker) {
                spinner?.remove();
                return;
            }

            const servicesList = res.data.services.data || [];

            if (empty(servicesList) && res.data.services.current_page === 1) {
                h.div(
                    {
                        class: "d-flex flex-column align-items-center justify-content-center py-5 mt-4 bg-light rounded-4 border w-100",
                        style: "min-height: 350px; border-style: dashed !important; border-width: 2px !important;",
                        parent: holder,
                        resetParent: true,
                    },
                    h.div(
                        {
                            class: "bg-white p-4 rounded-circle shadow-sm mb-4 d-flex align-items-center justify-content-center",
                            style: "width: 80px; height: 80px;",
                        },
                        h.i({ class: "bi bi-briefcase fs-1 text-primary" }),
                    ),
                    h.h4(
                        { class: "fw-bold text-dark mb-2" },
                        "No Services Found",
                    ),
                    h.p(
                        {
                            class: "text-secondary mb-4 text-center px-4",
                            style: "max-width: 400px;",
                        },
                        "You haven't added any services yet. Would you like to create one now?",
                    ),
                    h.button(
                        h.i({ class: "bi bi-plus-lg fs-5" }),
                        h.span({ class: "fw-semibold" }, "Add Service"),
                        {
                            class: "btn btn-primary btn-lg rounded-pill px-5 shadow-sm d-flex align-items-center gap-2 transition-all",
                            listeners: {
                                click: () =>
                                    router.to("business.services.add", {
                                        companyId: this.businessId,
                                    }),
                            },
                        },
                    ),
                );
            } else {
                if (res.data.services.current_page === 1 && holder) {
                    dom.empty(holder);
                }

                for (let service of servicesList) {
                    let id = `s-${service.id}`;
                    if (!dom.get(`[service-card-id="${id}"]`, holder)) {
                        this.renderServiceCard(service, holder);
                    }
                }

                if (this.page >= res.data.services.last_page && holder) {
                    this.lastPage = true;
                } else {
                    h.button(
                        h.i({
                            class: "bi bi-arrow-down-circle me-2 fs-5",
                            style: "line-height: 0;",
                        }),
                        "Load More",
                        {
                            parent: marker,
                            resetParent: true,
                            class: "btn btn-outline-primary d-flex align-items-center justify-content-center mx-auto my-4 rounded-pill px-4 fw-semibold",
                            listeners: {
                                click: () => this.fetchServices(marker),
                            },
                        },
                    );
                }
            }

            this.page = res.data.services.current_page + 1;
        } catch (e) {
            consoleErrorOnLocal(e);
            inform("Failed to load services", STRINGS.ERROR);
        } finally {
            this.loading.value = false;
            spinner?.remove();
        }
    }

    deleteService(id) {
        broker.send(
            $e.service.needs.deletion,
            payload({ id, businessId: this.businessId }),
        );
    }

    render() {
        const businessName = window.currentCompany?.name || "Business";

        pageInfo(`View Services - ${businessName}`);
        scrollToTop();

        // Notify the search bar that we are in services view
        dc.searchType = "services";

        return h.div(
            { class: "min-vh-100 py-5 mb-5 py-md-5" },
            h.div(
                { class: "container" },
                h.div(
                    {
                        class: "mb-5 d-flex align-items-center justify-content-between",
                    },
                    h.div(
                        { class: "d-flex align-items-center gap-3" },
                        h.button(
                            {
                                class: "btn btn-white border shadow-sm rounded-circle p-2",
                                listeners: {
                                    click: () => {
                                        dc.searchType = "products";
                                        router.to("business.services.manage", {
                                            companyId: this.businessId,
                                        });
                                    },
                                },
                            },
                            h.SolidIcon("arrow-left"),
                        ),
                        h.h2({ class: "fw-bold mb-0" }, "View Services"),
                    ),
                    h.button(
                        {
                            class: "btn btn-primary shadow-sm",
                            listeners: {
                                click: () =>
                                    router.to("business.services.add", {
                                        companyId: this.businessId,
                                    }),
                            },
                        },
                        h.i({ class: "bi bi-plus me-2" }),
                        "Add",
                    ),
                ),

                v(this.loading, (l) => {
                    if (l.value) {
                        return h.div(
                            { class: "text-center py-5" },
                            h.div({ class: "spinner-border text-primary" }),
                        );
                    }

                    return h.InfiniteScroll({
                        child: h.div({
                            class: "row g-4 w-100 m-0",
                            hook: "vs-services-list",
                        }),
                        callback: (entries, observer, marker) => {
                          if (entries[0]?.isIntersecting && !this.lastPage) {
                                this.fetchServices(marker);
                            }
                        },
                    });
                }),
            ),
        );
    }

    renderServiceCard(service, parent) {
        h.div(
            {
                class: "col-12 col-md-6 col-lg-4",
                "service-card-id": `s-${service.id}`,
                parent,
            },
            h.div(
                {
                    class: "card border-0 shadow-sm h-100 overflow-hidden",
                    style: "border-radius: 15px;",
                },
                // 16:9 Aspect Ratio Image / Placeholder Header
                h.div(
                    {
                        class: "ratio ratio-16x9 bg-light border-bottom overflow-hidden position-relative",
                        style: "background: #f8f9fa;",
                    },
                    service.thumbnail
                        ? h.img({
                              src: service.thumbnail,
                              class: "w-100 h-100 object-fit-cover",
                              alt: service.name,
                              loading: "lazy",
                          })
                        : h.div(
                              {
                                  class: "w-100 h-100 d-flex flex-column align-items-center justify-content-center text-muted p-3 bg-light",
                              },
                              h.i({ class: "bi bi-image fs-1 mb-2 text-secondary opacity-50" }),
                              h.span({ class: "small text-secondary fw-semibold" }, "No Service Image")
                          )
                ),
                h.div(
                    { class: "card-body p-4 d-flex flex-column" },
                    h.div(
                        {
                            class: "d-flex justify-content-between align-items-start mb-3 w-100",
                        },
                        h.h5({ class: "fw-bold mb-0" }, service.name),
                        h.div(
                            { class: "dropdown" },
                            h.button(
                                {
                                    class: "btn btn-sm btn-light rounded-circle",
                                    "data-bs-toggle": "dropdown",
                                },
                                h.i({ class: "bi bi-three-dots-vertical" }),
                            ),
                            h.ul(
                                {
                                    class: "dropdown-menu dropdown-menu-end shadow-sm border-0",
                                },
                                h.li(
                                    {},
                                    h.button(
                                        {
                                            class: "dropdown-item",
                                            listeners: {
                                                click: () =>
                                                    router.to(
                                                        "business.services.edit",
                                                        {
                                                            companyId:
                                                                this.businessId,
                                                            serviceId:
                                                                service.id,
                                                        },
                                                    ),
                                            },
                                        },
                                        h.i({ class: "bi bi-pencil me-2" }),
                                        "Edit",
                                    ),
                                ),
                                h.li(
                                    {},
                                    h.button(
                                        {
                                            class: "dropdown-item text-danger",
                                            listeners: {
                                                click: () =>
                                                    this.deleteService(
                                                        service.id,
                                                    ),
                                            },
                                        },
                                        h.i({ class: "bi bi-trash me-2" }),
                                        "Delete",
                                    ),
                                ),
                            ),
                        ),
                    ),
                    h.div(
                        {
                            class: "text-muted small mb-3 flex-grow-1",
                        },
                        service.description || "No description provided.",
                    ),
                    h.div(
                        {
                            class: "d-flex justify-content-between align-items-center mt-auto pt-3 border-top w-100",
                        },
                        h.div(
                            { class: "d-flex flex-column" },
                            h.span({ class: "text-muted small fw-semibold", style: "font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.5px;" }, "Base Price"),
                            h.span(
                                { class: "fw-bold text-primary fs-5" },
                                monetary(service.price, dc.userCurrency),
                            ),
                        ),
                        service.requirements && service.requirements.length > 0
                            ? h.span(
                                  {
                                      class: "badge bg-light text-dark border py-2 px-3 rounded-pill fw-semibold small",
                                  },
                                  `${service.requirements.length} Requirements`,
                              )
                            : h.empty(),
                    ),
                ),
            ),
        );
    }
}

ojs(ViewServices);
